/**
 * Common names people type that are not already the species name or an
 * Also Known As value in the catalog. Keyed by slug.
 */
export const SPECIES_SEARCH_ALIASES: Record<string, readonly string[]> = {
  "allium-canadense": ["meadow garlic"],
  "amelanchier-alnifolia": ["saskatoon", "juneberry", "shadbush"],
  "apios-americana": ["hopniss", "potato bean"],
  "armillaria-mellea": ["honey fungus"],
  "auricularia-americana": ["jelly ear"],
  "boletus-edulis": [
    "porcini",
    "porcino",
    "cep",
    "ceps",
    "cèpe",
    "penny bun",
    "steinpilz",
  ],
  "butyriboletus-rex-veris": ["spring porcini"],
  "cantharellus-spp": ["girolle", "girolles"],
  "chamerion-angustifolium": ["willowherb", "rosebay willowherb"],
  "coprinus-comatus": ["lawyer's wig", "shaggy inkcap"],
  "craterellus-tubaeformis": ["yellowfoot", "yellow foot", "funnel chanterelle"],
  "daucus-carota": ["queen anne's lace"],
  "elaeagnus-umbellata": ["autumnberry", "silverberry"],
  "fagus-grandifolia": ["beechnut"],
  "fistulina-hepatica": ["ox tongue"],
  "flammulina-velutipes": ["enoki", "enokitake", "velvet shank"],
  "ganoderma-tsugae": ["lingzhi"],
  "hen-of-the-woods": ["sheepshead", "sheep's head"],
  "hericium-erinaceus": ["yamabushitake"],
  "inonotus-obliquus": ["clinker polypore"],
  "juglans-cinerea": ["white walnut"],
  "laetiporus-spp": ["sulfur shelf", "chicken fungus"],
  "matteuccia-struthiopteris": ["ostrich fern"],
  "morels": ["sponge mushroom", "merkel", "merkels"],
  "opuntia-humifusa": ["nopal", "nopales", "cactus pear"],
  "pinus-edulis": ["pine nut", "piñon", "pinon"],
  "quercus-alba": ["acorn"],
  "sagittaria-latifolia": ["duck potato", "indian potato"],
  "vaccinium-spp": ["huckleberry", "bilberry"],
  "zizania-palustris": ["manoomin"],
};

export function searchAliasesForSlug(slug?: string | null): readonly string[] {
  const key = slug?.trim().toLowerCase();
  if (!key) return [];
  return SPECIES_SEARCH_ALIASES[key] ?? [];
}
